import _slicedToArray from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import { ELSTooltip } from "components/common/elsevier/Tooltip/Tooltip";
import { ELSLink } from "components/common/elsevier/Link/Link";
import * as EVUrl from "components/common/utils/EVUrl";
import { ELSGrid } from "components/common/elsevier/Grid/Grid";
import React, { useRef, useEffect, useState } from "react";
import { ELSModal } from "components/common/elsevier/Modal/Modal";
import { ELSButton } from "components/common/elsevier/Button/Button";
import { ELSBox } from "components/common/elsevier/Box/Box";
import { ELSIconButton } from "components/common/elsevier/Button/IconButton";
import CloseIcon from "components/common/elsevier/Icons/CloseIcon";
import { ELSTypography } from "components/common/elsevier/Typography/Typography";
import styles from "./Styles.module.scss";
export default function HistoryRow(_ref) {
  var history = _ref.history,
    item = _ref.item;
  var containerRef = useRef(null);
  var _useState = useState(false),
    isTruncated = _useState[0],
    setIsTruncated = _useState[1];
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var _useState2 = useState(false),
    setCopySuccess = _useState2[1];
  var handleOpen = function handleOpen() {
    return setOpen(true);
  };
  var handleClose = function handleClose() {
    // reset state
    setCopySuccess(false);
    setOpen(false);
  };
  useEffect(function () {
    // Access the width of the container after the component is mounted
    var container = containerRef.current;
    if (container) {
      setIsTruncated(container.scrollWidth > container.clientWidth);
      window.addEventListener("resize", function (event) {
        setIsTruncated(container.scrollWidth > container.clientWidth);
      });
    }
    return function () {
      return window.removeEventListener("resize", function (event) {});
    };
  }, []);
  var copyToClipboard = function copyToClipboard(e) {
    navigator.clipboard.writeText(history.intermediatequery);
    e.target.focus();
    setCopySuccess(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ELSGrid, {
    className: styles["recently-searched__result"],
    item: true,
    xs: 9,
    key: "search-history-".concat(item)
  }, /*#__PURE__*/React.createElement(ELSTooltip, {
    title: history.intermediatequery
  }, /*#__PURE__*/React.createElement(ELSLink, {
    className: "".concat(styles["recently-searched__result-link"], " ev__search-history-query es-link__black--16-font"),
    href: EVUrl.buildExpertSearchUrl(history.searchId, "1", history.databasemask, history.searchtype, "searchhistory", "searcheslist"),
    "data-aa-region": "recently searched"
  }, /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: styles["recently-searched__query"],
    "data-cy": "recent-search-history--search-query"
  }, history.intermediatequery)))), /*#__PURE__*/React.createElement(ELSGrid, {
    className: styles["recently-searched__result"],
    item: true,
    xs: 1
  }, isTruncated && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ELSButton, {
    onClick: handleOpen,
    className: "es-link__blue--16-font ".concat(styles["recently-searched__view-more-button"]),
    "data-cy": "recent-search-history--view-more"
  }, "View more"), /*#__PURE__*/React.createElement(ELSModal, {
    className: "".concat(styles.modal),
    open: open,
    onClose: handleClose,
    "aria-label": "View more Query modal",
    "aria-modal": "true",
    role: "dialog",
    "data-cy": "recent-search-history-modal"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ELSBox, {
    className: "__wrapper"
  }, /*#__PURE__*/React.createElement(ELSIconButton, {
    className: "__close --colored ".concat(styles["modal__close-button"]),
    "aria-label": "Close View more Query modal",
    onClick: handleClose,
    "data-cy": "recent-search-history-modal--close-button"
  }, /*#__PURE__*/React.createElement(CloseIcon, null)), /*#__PURE__*/React.createElement("div", {
    className: styles.modal__title,
    id: "modal-title",
    "data-cy": "recent-search-history-modal--title"
  }, "Recently searched query"), /*#__PURE__*/React.createElement("div", {
    className: styles.modal_results,
    "data-cy": "recent-search-history-modal--results"
  }, history.resultsCountWithCommas, " results"), /*#__PURE__*/React.createElement(ELSLink, {
    className: "".concat(styles["recently-searched__result-link"], " ev__search-history-query es-link__black--16-font"),
    href: EVUrl.buildExpertSearchUrl(history.searchId, "1", history.databasemask, history.searchtype, "searchhistory", "searcheslist"),
    "data-cy": "recent-search-history-modal--link"
  }, /*#__PURE__*/React.createElement(ELSTypography, {
    className: styles.modal__query,
    "data-cy": "recent-search-history-modal--query"
  }, history.intermediatequery))), /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    item: true,
    xs: 12,
    md: 12,
    lg: 12,
    alignItems: "flex-end",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement("span", {
    className: styles["modal__button-span"]
  })))))), /*#__PURE__*/React.createElement(ELSGrid, {
    className: styles["recently-searched__result"],
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement("span", {
    className: styles["recently-searched__result-num"],
    "data-cy": "recent-search-history--results"
  }, history.resultsCountWithCommas, " results")));
}